import React from 'react'
import CV from '../../assets/MyCv.pdf'
const CTA = () => {
    return (
        <div className='cta'>
            <a href= {CV} download className='btn'>Download CV</a>
            <a href="#contact" className="chat">Let's chat</a>
        </div>
    )
}

export default CTA
